import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';

const SocketContext = createContext(null);

export function SocketProvider({ children }) {
  const [socket, setSocket] = useState(null);
  const [waStatus, setWaStatus] = useState('disconnected');
  const [qrCode, setQrCode] = useState(null);
  const [qrTimestamp, setQrTimestamp] = useState(null);
  const [pairingCode, setPairingCode] = useState(null);

  useEffect(() => {
    // Ensure the WhatsApp client is running for this user (cookie sent automatically)
    fetch('/api/whatsapp/init', {
      method: 'POST',
      credentials: 'include',
    }).catch(() => {});

    // Fetch current status + QR via HTTP so the panel loads immediately without waiting for socket
    fetch('/api/whatsapp/qr', { credentials: 'include' })
      .then((res) => res.json())
      .then((data) => {
        if (data.status) setWaStatus(data.status);
        if (data.qr) { setQrCode(data.qr); setQrTimestamp(Date.now()); }
        if (data.pairingCode) setPairingCode(data.pairingCode);
      })
      .catch(() => {});

    const s = io('/admin', {
      withCredentials: true, // send httpOnly cookie with socket handshake
    });

    s.on('connect', () => console.log('Socket connected'));
    s.on('wa_status', ({ status }) => {
      setWaStatus(status);
      if (status === 'ready') { setQrCode(null); setPairingCode(null); }
    });
    s.on('wa_qr', ({ qr }) => { setQrCode(qr); setQrTimestamp(Date.now()); setPairingCode(null); });
    s.on('wa_pair_code', ({ code }) => { setPairingCode(code); });

    setSocket(s);
    return () => s.disconnect();
  }, []);

  return (
    <SocketContext.Provider value={{ socket, waStatus, qrCode, qrTimestamp, pairingCode }}>
      {children}
    </SocketContext.Provider>
  );
}

export const useSocket = () => useContext(SocketContext);
